import { Pipe, PipeTransform } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { QualificationOutcome } from 'src/app/core/enums/lead/qualification-outcome.enum';
import { QualificationStatus } from 'src/app/core/enums/lead/qualification-status.enum';
import { LeadHead } from 'src/app/core/models/lead/lead-head.model';

@Pipe({
    name: 'translateLeadOutcome',
    pure: false,
    standalone: false
})
export class TranslateLeadOutcomePipe implements PipeTransform {

  constructor(private translatePipe: TranslatePipe) {
  }

  transform(value: LeadHead): string | undefined {
    if (value.qualificationStatus == QualificationStatus.Unknown) return ''
    if (value.qualificationOutcome != QualificationOutcome.Unknown) return this.translatePipe.transform('enums.qualificationOutcome.' + value.qualificationOutcome)
    else return this.translatePipe.transform('enums.qualificationStatus.' + value.qualificationStatus)
  }

}
